import WrapperService from "@/modules/core/services/wrapper-service";

const serviceName = "RoleAuth-Service: ";

export default class RoleAuthService {

  static async checkAdminRole(successF, errorF) {
    await WrapperService.get(process.env.VUE_APP_ROOT_API + "/api/v1/auth/admin", null, serviceName, successF, errorF);
  }

  static async checkOperatorRole(successF, errorF) {
    await WrapperService.get(process.env.VUE_APP_ROOT_API + "/api/v1/auth/operator", null, serviceName, successF, errorF);
  }

  static async checkManagerRole(successF, errorF) {
    await WrapperService.get(process.env.VUE_APP_ROOT_API + "/api/v1/auth/manager", null, serviceName, successF, errorF);
  }

  static async checkMainRole(successF, errorF) {
    await WrapperService.get(process.env.VUE_APP_ROOT_API + "/api/v1/auth/main", null, serviceName, successF, errorF);
  }

  static async readAuthorities(successF, errorF) {
    await WrapperService.get(process.env.VUE_APP_ROOT_API + "/api/v1/auth/authorities", null, serviceName, successF, errorF);
  }

  static async readDisplayAuthorities(successF, errorF) {
    await WrapperService.get(process.env.VUE_APP_ROOT_API + "/api/v1/auth/display/authorities", null, serviceName, successF, errorF);
  }
}
